import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appPreventDoubleClick]',
  standalone: true
})
export class PreventDoubleClickDirective {
  constructor(private elementRef: ElementRef) {
    (this.elementRef.nativeElement as HTMLElement).addEventListener(
      'click',
      $event => {
        if (!$event['detail'] || $event['detail'] === 1) {
          return true;
        } else {
          $event.stopPropagation();
          return false;
        }
      },
      true
    );
  }
}
